"use client";

import * as React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/core/utils";

/**
 * Shared class for field / section captions — uppercase, muted.
 * Truncates with ellipsis in narrow layouts; pair with `title` on the element when helpful.
 */
export const FORM_LABEL_CLASS =
  "block w-full min-w-0 max-w-full truncate text-[11px] font-medium uppercase tracking-wider text-slate-500";

const labelVariants = cva(
  [
    FORM_LABEL_CLASS,
    "peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
  ].join(" ")
);

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> &
    VariantProps<typeof labelVariants>
>(({ className, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(labelVariants(), className)}
    {...props}
  />
));
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
